<script>
  import http from '@/service/http'
  import findIndex from 'lodash/findIndex'
  import { mapState, mapGetters } from 'vuex'
  import moment from 'moment'

  export default {
    name: 'Pagar',
    data () {
      return {
        list: [],
        filtro: {
          busca: '',
          conta: ''
        },
        total: '0,00',
        contas: [],
        pago: []
      }
    },
    mounted () {
      this.filtrar()
    },
    methods: {
      formatDate (date) {
        return moment(date).format('DD/MM/YYYY')
      },
      async filtrar () {
        this.busca = ''
        const {data} = await http.get(`financeiro/pagar/atraso?conta=${this.filtro.conta}&busca=${this.filtro.busca}`)
        this.list = data.rows.data
        this.filtro = data.filtro
        this.total = data.total
        this.contas = data.contas
        setTimeout(function () {
          window.Materialize.updateTextFields()
        }, 0)
      },
      async updateList (obj) {
        this.filtrar()
        window.Materialize.toast('Registro salvo com sucesso!!', 4000)
      },
      destroy (pagar) {
        this.$swal({
          title: `Deseja remover ${pagar.descricao}?`,
          html: 'Esta operação é irreversível',
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          cancelButtonColor: '#d33',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Sim, quero excluir!',
          reverseButtons: true
        }).then(async () => {
          const {data} = await http.delete(`/financeiro/pagar/${pagar.id}`)
          if (data != null) {
            const index = await findIndex(this.list, {id: pagar.id})
            if (index > -1) {
              this.list.splice(index, 1)
              window.Materialize.toast('Registro removido com sucesso!!', 4000)
            }
          }
        })
      },
      pagamentoMassa () {
        http.post('/financeiro/pagar/massa', this.pago)
          .then(data => {
            this.pago = []
            this.busca = ''
            this.fecth()
          })
      }
    },
    computed: {
      ...mapState(['loading']),
      ...mapGetters(['permissoes']),
      api_url () {
        return process.env.API_URL
      },
      hasItens () {
        return this.list.length > 0
      }
    }
  }
</script>

<template>
  <div>

    <div class="content">

      <div class="row">
        <div class="col s12 m11">
          <h5>Financeiro :: Contas a Pagar em Atraso :: R$ {{ total }}</h5>
        </div>
        <div class="col s12 m1 input-field right-align">
          <router-link :to="{ name: 'financeiro-pagar.index' }" class="btn-floating btn-large waves-effect waves-light red"><i class="material-icons">close</i></router-link>
        </div>
      </div>

      <div class="row">
        <div class="col s12 m10">
          <form @submit.prevent="filtrar">
            <div class="row">

              <div class="col s12 m2">
                <label for="filtro_conta">Conta Bancária</label>
                <select name="conta" id="filtro_conta" v-model="filtro.conta">
                  <option v-for="conta in contas" :value="conta.id">{{ (conta.id) ? conta.conta : 'Todas' }}</option>
                </select>
              </div>

              <div class="input-field col s12 m3">
                <input id="busca" type="text" v-model="filtro.busca">
                <label for="busca">Buscar</label>
              </div>

              <div class="input-field col s12 m1">
                <button class="waves-effect waves-light btn">Filtrar
                </button>
                <label></label>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="center-align" v-show="!hasItens && !loading">
        <p>Nenhum registro encontrado!</p>
      </div>

      <div class="row z-depth-1" v-show="hasItens">
        <div class="col s12">
          <table class="responsive-table bordered highlight">
            <thead>
            <tr>
              <th>Vencimento</th>
              <th>Descrição</th>
              <th>R$ Pagar</th>
              <th class="right-align">Ações</th>
            </tr>
            </thead>

            <tbody>
            <tr v-for="pagar in list">
              <td>{{ formatDate(pagar.vencimento) }}</td>
              <td>
                <router-link :to="{ name: 'financeiro-pagar.form', params: { id: pagar.id } }"
                             v-if="permissoes.indexOf('financeiro-pagar.editar') > -1">{{ pagar.descricao }}
                </router-link>
                <span v-else>{{ pagar.descricao }}</span>
                {{ (pagar.parcela !== '1/1') ? pagar.parcela : '' }}<br/>
                <small>{{ pagar.fornecedor ? pagar.fornecedor.fornecedor : '' }} {{ pagar.fornecedor && pagar.conta ?
                  '|' : '' }} {{ pagar.conta ? pagar.conta.conta : '' }}
                </small>
              </td>
              <td>{{ pagar.valor_pago }}</td>
              <td class="right-align">
                <input type="checkbox" :id="pagar.id" v-model="pago" :value="pagar.id"
                       v-if="!pagar.pago && permissoes.indexOf('financeiro-pagar.editar') > -1"/><label
                :for="pagar.id"></label>
                <router-link :to="{ name: 'financeiro-pagar.form', params: { id: pagar.id } }"
                             v-show="permissoes.indexOf('financeiro-pagar.editar') > -1"><i
                  class="material-icons blue-text">edit</i></router-link>
                <a href="#" @click.prevent="destroy(pagar)"
                   v-show="permissoes.indexOf('financeiro-pagar.excluir') > -1">
                  <i class="material-icons red-text">delete_forever</i>
                </a>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="row" v-show="pago.length > 0 && showBtNovo && hasItens"
           style="position: fixed; bottom: 10px; width: 100%;">
        <div class="col s12 center-align">
          <a class="waves-effect waves-light btn" @click.prevent="pagamentoMassa()"><i class="material-icons left">refresh</i>
            definir item(s) como pagos</a>
        </div>
      </div>

    </div>
  </div>
</template>



// WEBPACK FOOTER //
// src/features/financeiro/pagar/atrasado.vue